var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZendeskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0855 19.0938H-0.000226562L11.0855 5.71075V19.0938ZM23.9998 19.0938H12.914C12.9379 17.6394 13.5325 16.2527 14.5694 15.2326C15.6064 14.2126 17.0027 13.6409 18.4573 13.6409C19.9118 13.6409 21.3081 14.2126 22.3451 15.2326C23.3821 16.2527 23.9766 17.6394 24.0005 19.0938H23.9998ZM12.914 14.2892V0.90625H23.9998L12.914 14.2892ZM11.0855 0.90625C11.0616 2.36062 10.4671 3.74733 9.4301 4.76737C8.39314 5.78741 6.99684 6.35906 5.54227 6.35906C4.08771 6.35906 2.69141 5.78741 1.65445 4.76737C0.617489 3.74733 0.0229485 2.36062 -0.000976562 0.90625H11.0855Z",
    fill: "#2D3436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendeskLogo);
export default __webpack_public_path__ + "static/media/zendesk-logo.54d5c9bea5cec5b4229e6735b80e3b83.svg";
export { ForwardRef as ReactComponent };